import { useEffect } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { isTestEnvironment } from "../../utils/environment";

// Telas públicas ficam sempre no tema claro (ver ThemeContext): trocar o tema
// ali não teria efeito visível, só mudaria a escolha salva.
const PUBLIC_LIGHT_PREFIXES = [
  "/form/",
  "/card-form/",
  "/agendar/",
  "/agendamento/",
  "/politica-privacidade",
];

const isEditableTarget = (target) => {
  if (!target || typeof target !== "object") return false;
  const tag = String(target.tagName || "").toUpperCase();
  return (
    target.isContentEditable ||
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT"
  );
};

/**
 * Atalho SÓ DE TESTE: a tecla P alterna entre o tema claro e o escuro em
 * qualquer tela e em qualquer modal, para quem testa na UAT conferir os dois
 * temas sem abrir o menu do usuário. Só liga em UAT e no desenvolvimento local
 * (`utils/environment.js`); no build de produção o componente nem registra o
 * ouvinte. Escuta em fase de captura no `document`, antes de qualquer modal ou
 * campo, e nunca age com o foco num campo de digitação, para não trocar o tema
 * enquanto a pessoa escreve um "p".
 */
export default function UatThemeShortcut() {
  const { toggleTheme } = useTheme();

  useEffect(() => {
    if (!isTestEnvironment()) return undefined;
    const onKeyDown = (event) => {
      if (event.key?.toLowerCase() !== "p") return;
      if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) {
        return;
      }
      if (event.repeat || event.isComposing || event.defaultPrevented) return;
      if (isEditableTarget(event.target)) return;
      if (
        PUBLIC_LIGHT_PREFIXES.some((prefix) =>
          window.location.pathname.startsWith(prefix),
        )
      ) {
        return;
      }
      event.preventDefault();
      toggleTheme();
    };
    document.addEventListener("keydown", onKeyDown, true);
    return () => document.removeEventListener("keydown", onKeyDown, true);
  }, [toggleTheme]);

  return null;
}
